import { useMutation } from '@tanstack/react-query'
import { postNamedCommand } from '../service'

export const useCreateAltImportBatchMutation = () => {
  const mutation = useMutation({
    mutationFn: async ({ clientId, files }) => {
      const { data } = await postNamedCommand('ingestion', 'createAltImportBatch', { clientId, files })
      return data
    }
  })
  return {
    createImportBatch: mutation.mutateAsync,
    isLoading: mutation.isLoading
  }
}

export const useFinalizeAltImportBatchMutation = () => {
  const mutation = useMutation({
    mutationFn: async ({ batchId }) => {
      const { data } = await postNamedCommand('ingestion', 'finalizeAltImportBatch', { batchId })
      return data
    }
  })
  return {
    finalizeImportBatch: mutation.mutateAsync,
    isLoading: mutation.isLoading
  }
}
